<loader *ngIf="loading"></loader>

<div
  *ngIf="!loading && filterType"
  class="kpi-container"
  [class.clinics]="tag == '_clinics'"
>
  <div class="top-row">
    <owl-carousel-o
      [options]="customOptions"
      #owlCarTop
      (change)="onCarouselChange($event)"
    >
      <ng-template
        *ngIf="checkPermission('incoming_cases')"
        carouselSlide
        [width]="330"
        [id]="'incoming_cases'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">עבודות נכנסות</h2>
            <hr />
          </header>
          <div style="padding-top: 5px">
            <gen-kpi-doughnut
              *ngIf="todayOrdersDonut"
              [id]="'today_orders' + tag"
              [data]="todayOrdersDonut"
              [centerContent]="todayOrdersCenter"
              [size]="'250px'"
              [cutout]="'85%'"
            >
            </gen-kpi-doughnut>
          </div></div
      ></ng-template>

      <ng-template
        *ngIf="checkPermission('cumul_income')"
        carouselSlide
        [width]="500"
        [id]="'cumul_income'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">הזמנות מצטברות החודש</h2>
            <hr />
          </header>
          <div>
            <gen-kpi-cartesian
              [height]="'250px'"
              [id]="'cumul_income' + tag"
              [data]="cumulMonthIncome"
              [timeSw]="true"
              [customTooltipId]="'cumul_income_tooltip'"
              [displayUnit]="true"
            ></gen-kpi-cartesian>
          </div>
        </div>
      </ng-template>

      <ng-template
        *ngIf="checkPermission('case_delays')"
        carouselSlide
        [width]="230"
        [id]="'case_delays'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">עיכובים בעבודות</h2>
            <hr />
          </header>
          <div class="late-orders-box">
            <gen-kpi-circle
              *ngIf="kpi.caseDelays"
              [cnt]="kpi.caseDelays.plantCnt"
              [label]="'מתעכבות בייצור'"
              [circleColor]="kpi.caseDelays.plantCircleColor"
              [small]="true"
            ></gen-kpi-circle>

            <gen-kpi-circle
              *ngIf="kpi.caseDelays"
              [cnt]="kpi.caseDelays.labCnt"
              [label]="'מתעכבות במעבדה'"
              [circleColor]="kpi.caseDelays.labCircleColor"
              [small]="true"
            ></gen-kpi-circle>
          </div></div
      ></ng-template>

      <ng-template
        *ngIf="checkPermission('timing') && cycleDuration"
        carouselSlide
        [width]="280"
        [id]="'cycle_duration'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">זמן מחזור</h2>
            <hr />
          </header>
          <div>
            <gen-kpi-bar
              [height]="'260px'"
              [id]="'cycle_duration' + tag"
              [data]="cycleDuration"
              [customTooltipId]="'cycle_duration_tooltip'"
            ></gen-kpi-bar>
          </div>
        </div>
      </ng-template>

      <ng-template
        *ngIf="checkPermission('online_activity')"
        carouselSlide
        [width]="430"
        [id]="'online_activity'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">פעילות אונליין</h2>
            <hr />
          </header>
          <div class="online-activity-box">
            <gen-kpi-doughnut
              *ngIf="onlineActivityDonut"
              [id]="'online_activity' + tag"
              [data]="onlineActivityDonut"
              [size]="'260px'"
              [cutout]="'25%'"
              [dataLabels]="true"
            >
            </gen-kpi-doughnut>

            <gen-kpi-bar
              *ngIf="supplyOrders"
              [height]="'260px'"
              [width]="'140px'"
              [id]="'supply_orders' + tag"
              [data]="supplyOrders"
              [displayLegend]="false"
            ></gen-kpi-bar>
          </div>
        </div>
      </ng-template>

      <ng-template
        *ngIf="checkPermission('employee_performance')"
        carouselSlide
        [width]="900"
        [id]="'employee_performance'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <div class="header-row">
              <h2 class="t-widgetTitle">הכנסת עבודות</h2>
              <p-select
                *ngIf="employeePerformanceOptions.length > 0"
                class="t-input--colored"
                [options]="employeePerformanceOptions"
                [(ngModel)]="selectedEmployeePerformance"
                optionLabel="display"
              ></p-select>
            </div>
            <hr />
          </header>
          <div>
            <gen-kpi-cartesian
              *ngIf="selectedEmployeePerformance"
              [height]="'250px'"
              [id]="'employee_performance' + tag"
              [cartesianData]="selectedEmployeePerformance"
              [chartType]="'bar'"
              [timeSw]="false"
              [displayYAxis]="true"
              [displayLegend]="false"
            ></gen-kpi-cartesian>
          </div>
        </div>
      </ng-template>

      <ng-template
        *ngIf="checkPermission('clinic_stoplight')"
        carouselSlide
        [width]="500"
        [id]="'clinic_stoplight'"
      >
        <div class="t-widget--noPadding kpi-box t-scrollbar">
          <header class="l-flex-column l-align-top summary-box-header">
            <div class="l-align-spaceBetween w-full">
              <h2 class="t-widgetTitle">רמזור לקוח</h2>
            </div>

            <hr />
          </header>
          <div class="kpi-body t-scrollbar">
            <div class="metrics score">
              <div class="metric" [style.backgroundColor]="kpi.slColor">
                ציון {{ kpi.slScore }}
              </div>
            </div>

            <div class="metrics">
              <div
                *ngFor="let m of kpi.slMetrics"
                class="metric"
                [style.backgroundColor]="m.displayColor"
              >
                {{ m.descr }} - {{ m.score }}
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- <ng-template
        *ngIf="!clinicMode && isAgent"
        carouselSlide
        [width]="256"
        [id]="7"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">לקוחות נוטשים</h2>
            <hr />
          </header>
          <div class="invoices-box">
            <gen-kpi-circle
              *ngIf="kpi.abandonClients"
              [cnt]="kpi.abandonClients.cnt"
              [label]="kpi.abandonClients.label"
              [deltaCnt]="kpi.abandonClients.deltaCnt"
              [arrowType]="kpi.abandonClients.arrowType"
              [deltaColor]="kpi.abandonClients.deltaColor"
              [circleColor]="kpi.abandonClients.circleColor"
              [labelColor]="kpi.abandonClients.circleColor"
              [large]="true"
              (click)="stoplightClick('ABANDON', kpi.abandonClients.cnt)"
            ></gen-kpi-circle>
          </div>
        </div>
      </ng-template> -->
    </owl-carousel-o>
  </div>

  <div class="bottom-row">
    <owl-carousel-o
      *ngIf="cartesianTabsAvailable.length > 0"
      [options]="customOptions"
      #owlCarBottom
      (change)="onCarouselChange($event)"
    >
      <ng-template carouselSlide [width]="1000" [id]="'cartesian_tabs'">
        <div class="t-widget--noPadding kpi-box" style="flex-grow: 1">
          <header class="l-flex-column l-align-top summary-box-header">
            <div class="t-widgetTitle">
              <a
                *ngIf="cartesianTabsAvailable.includes('profit_trends')"
                [class.selected]="cartesianTabSelected == 'profit_trends'"
                (click)="cartesianTabSelected = 'profit_trends'"
                >מחזור</a
              >
              <span
                *ngIf="cartesianTabsAvailable.includes('profit_trends')"
                class="divider"
              ></span>
              <a
                *ngIf="cartesianTabsAvailable.includes('return_trends')"
                [class.selected]="cartesianTabSelected == 'return_trends'"
                (click)="cartesianTabSelected = 'return_trends'"
                >עבודות חוזרות</a
              ><span
                *ngIf="cartesianTabsAvailable.includes('return_trends')"
                class="divider"
              ></span>
              <a
                *ngIf="cartesianTabsAvailable.includes('fix_trends')"
                [class.selected]="cartesianTabSelected == 'fix_trends'"
                (click)="cartesianTabSelected = 'fix_trends'"
                >תיקונים</a
              ><span
                *ngIf="cartesianTabsAvailable.includes('fix_trends')"
                class="divider"
              ></span>
              <a
                *ngIf="cartesianTabsAvailable.includes('try_in_trends')"
                [class.selected]="cartesianTabSelected == 'try_in_trends'"
                (click)="cartesianTabSelected = 'try_in_trends'"
                >מדידות</a
              ><span class="divider"></span>
              <a
                *ngIf="cartesianTabsAvailable.includes('scan_analog')"
                [class.selected]="cartesianTabSelected == 'scan_analog'"
                (click)="cartesianTabSelected = 'scan_analog'"
                >דיגיטל</a
              >
            </div>
            <hr />
          </header>
          <div>
            <gen-kpi-cartesian
              *ngIf="cartesianTabSelected == 'profit_trends' && periodicProfit"
              [height]="'440px'"
              [id]="'periodic_profit' + tag"
              [data]="periodicProfit"
              [timeSw]="false"
              [customTooltipId]="'periodic_profit_tooltip'"
              [displayYAxis]="false"
            ></gen-kpi-cartesian>

            <gen-kpi-cartesian
              *ngIf="cartesianTabSelected == 'return_trends' && returnTrends"
              [height]="'440px'"
              [id]="'returns' + tag"
              [data]="returnTrends"
              [timeSw]="false"
              [customTooltipId]="'returns_tooltip'"
              [displayYAxis]="true"
              [formatAxisAsPct]="true"
            ></gen-kpi-cartesian>

            <gen-kpi-cartesian
              *ngIf="cartesianTabSelected == 'fix_trends' && fixTrends"
              [height]="'440px'"
              [id]="'fix' + tag"
              [data]="fixTrends"
              [timeSw]="false"
              [customTooltipId]="'fix_tooltip'"
              [displayYAxis]="true"
              [formatAxisAsPct]="true"
            ></gen-kpi-cartesian>

            <gen-kpi-cartesian
              *ngIf="cartesianTabSelected == 'try_in_trends' && tryInTrends"
              [height]="'440px'"
              [id]="'try_in' + tag"
              [data]="tryInTrends"
              [timeSw]="false"
              [customTooltipId]="'try_in_tooltip'"
              [displayYAxis]="true"
              [formatAxisAsPct]="true"
            ></gen-kpi-cartesian>

            <gen-kpi-cartesian
              *ngIf="cartesianTabSelected == 'scan_analog' && digitalOrders"
              [height]="'440px'"
              [id]="'digital_orders' + tag"
              [data]="digitalOrders"
              [timeSw]="false"
              [customTooltipId]="'digital_orders_tooltip'"
              [displayYAxis]="true"
              [formatAxisAsPct]="true"
            ></gen-kpi-cartesian>
          </div>
        </div>
      </ng-template>

      <!-- <ng-template
        *ngIf="checkPermission('item_composition')"
        carouselSlide
        [width]="560"
        [id]="'item_composition'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">פילוח מוצרים</h2>
            <hr />
            <div class="radar-box">
              <gen-kpi-radar
                *ngIf="itemsRadar"
                [height]="'460px'"
                [width]="'500px'"
                [id]="'items_radar' + tag"
                [data]="itemsRadar"
                [showTooltip]="true"
                [showNumbers]="false"
                [customTooltipId]="'items_radar_tooltip'"
              ></gen-kpi-radar>
            </div>
          </header>
        </div>
      </ng-template> -->

      <ng-template
        *ngIf="checkPermission('client_stoplight')"
        carouselSlide
        [width]="180"
        [id]="'client_stoplight'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">רמזור לקוחות</h2>
            <hr />
          </header>
          <div class="clinic-classify-box">
            <gen-kpi-circle
              *ngIf="kpi.greenClients"
              [cnt]="kpi.greenClients.cnt"
              [label]="kpi.greenClients.label"
              [pct]="kpi.greenClients.deltaPct"
              [arrowType]="kpi.greenClients.arrowType"
              [deltaColor]="kpi.greenClients.deltaColor"
              [circleColor]="kpi.greenClients.circleColor"
              (click)="stoplightClick('GREEN', kpi.greenClients.cnt)"
            ></gen-kpi-circle>

            <gen-kpi-circle
              *ngIf="kpi.yellowClients"
              [cnt]="kpi.yellowClients.cnt"
              [label]="kpi.yellowClients.label"
              [pct]="kpi.yellowClients.deltaPct"
              [arrowType]="kpi.yellowClients.arrowType"
              [deltaColor]="kpi.yellowClients.deltaColor"
              [circleColor]="kpi.yellowClients.circleColor"
              (click)="stoplightClick('YELLOW', kpi.yellowClients.cnt)"
            ></gen-kpi-circle>

            <gen-kpi-circle
              *ngIf="kpi.redClients"
              [cnt]="kpi.redClients.cnt"
              [label]="kpi.redClients.label"
              [pct]="kpi.redClients.deltaPct"
              [arrowType]="kpi.redClients.arrowType"
              [deltaColor]="kpi.redClients.deltaColor"
              [circleColor]="kpi.redClients.circleColor"
              (click)="stoplightClick('RED', kpi.redClients.cnt)"
            ></gen-kpi-circle>
          </div>
        </div>
      </ng-template>

      <ng-template
        *ngIf="checkPermission('invoices')"
        carouselSlide
        [width]="570"
        [id]="'invoices'"
      >
        <div class="t-widget--noPadding kpi-box">
          <header class="l-flex-column l-align-top summary-box-header">
            <h2 class="t-widgetTitle">חשבוניות</h2>
            <hr />
          </header>
          <div class="invoices-box">
            <div class="graphs-row-1">
              <gen-kpi-doughnut
                *ngIf="invoicesDonut"
                [id]="'invoices_clients' + tag"
                [data]="invoicesDonut"
                [size]="'350px'"
                [cutout]="'25%'"
                [dataLabels]="true"
              >
              </gen-kpi-doughnut>
            </div>

            <div class="graphs-row-2">
              <gen-kpi-circle
                *ngIf="kpi.abandonClients"
                [cnt]="kpi.abandonClients.cnt"
                [label]="kpi.abandonClients.label"
                [deltaCnt]="kpi.abandonClients.deltaCnt"
                [arrowType]="kpi.abandonClients.arrowType"
                [deltaColor]="kpi.abandonClients.deltaColor"
                [circleColor]="kpi.abandonClients.circleColor"
                [labelColor]="kpi.abandonClients.circleColor"
                [large]="true"
                (click)="stoplightClick('ABANDON', kpi.abandonClients.cnt)"
              ></gen-kpi-circle>
              <span style="height: 5px"></span>
              <gen-kpi-circle
                class="acuisition-fail"
                *ngIf="kpi.acuisitionFailClients"
                [cnt]="kpi.acuisitionFailClients.cnt"
                [label]="kpi.acuisitionFailClients.label"
                [pct]="kpi.acuisitionFailClients.deltaPct"
                [deltaCnt]="kpi.acuisitionFailClients.deltaCnt"
                [deltaColor]="kpi.acuisitionFailClients.deltaColor"
                [circleColor]="kpi.acuisitionFailClients.circleColor"
                [large]="true"
                (click)="
                  stoplightClick(
                    'ACUISITION_FAIL',
                    kpi.acuisitionFailClients.cnt
                  )
                "
              ></gen-kpi-circle>
            </div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>

  <ng-template #todayOrdersCenter>
    <div class="center-el todayOrders">
      <div
        class="weekday-lbl"
        [class.red]="kpi.allIncomingCases.circleColor == 'RED'"
        [class.green]="kpi.allIncomingCases.circleColor == 'GREEN'"
        [class.yellow]="kpi.allIncomingCases.circleColor == 'YELLOW'"
      >
        {{ kpi.allIncomingCases.label }}
        <i
          class="fas"
          [class.fa-arrow-up]="kpi.allIncomingCases.arrowType == 'UP'"
          [class.fa-arrow-down]="kpi.allIncomingCases.arrowType == 'DOWN'"
        ></i>
      </div>
      <div class="orders-lbl">{{ kpi.allIncomingCases.cnt }}</div>
      <div class="txt-lbl">עבודות חדשות התקבלו היום</div>
    </div>
  </ng-template>
</div>

<modal-popup
  *ngIf="displayClinicList"
  [flexible]="true"
  [hideHeader]="false"
  [isOpen]="displayClinicList"
  [focusOnOpen]="false"
  [draggable]="true"
  [title]="clinicListTitle"
  (onClose)="displayClinicList = false"
  class="colored-header"
>
  <div class="clinic-list-container">
    <loader *ngIf="clinicsStoplightLoading"></loader>
    <div *ngIf="!clinicsStoplightLoading">
      <div
        *ngFor="let c of clinics"
        class="clinic"
        [class.expanded]="c.expanded"
      >
        <div
          class="l-align-spaceBetween t-pointer"
          (click)="c.expanded = !c.expanded; toggleSnoozeInput = false"
        >
          <div class="l-align-center col-gap-sm">
            <span [class.fw-bold]="c.expanded">{{ c.clinicDescr }}</span>

            <img
              *ngIf="c.snoozeStartdate"
              class="snooze-icon"
              src="assets\img\snooze_grey.svg"
            />
          </div>
          <i class="fas fa-angle-down t-popupCloseIcon"></i>
        </div>

        <slide-in-out [isOpen]="c.expanded">
          <div *ngIf="c.snoozeStartdate" class="snooze-info">
            <p>
              חשבון נכנס להשהייה בתאריך
              {{ c.snoozeStartdate | date : "dd/MM/yy" }}
            </p>
            <p *ngIf="c.snoozeNote" class="snooze-note">"{{ c.snoozeNote }}"</p>
          </div>

          <div class="metrics">
            <div
              *ngFor="let m of c.metrics"
              class="metric"
              [style.backgroundColor]="m.displayColor"
            >
              {{ m.descr }} - {{ m.score }}
            </div>
          </div>

          <div class="l-align-spaceBetween clinic-list-actions">
            <button
              class="l-align-center snooze-btn"
              [class.hidden]="!abandonClinicsSw"
              [class.active]="toggleSnoozeInput"
              [class.t-button]="toggleSnoozeInput"
              [class.t-button-outline]="!toggleSnoozeInput"
              (click)="toggleSnoozeArea($event)"
            >
              <img
                *ngIf="!toggleSnoozeInput"
                class="snooze-icon"
                src="assets\img\snooze_blue.svg"
              />
              <img
                *ngIf="toggleSnoozeInput"
                class="snooze-icon"
                src="assets\img\snooze_white.svg"
              />
              השהיית חשבון
            </button>

            <a class="metrics-link" (click)="goToClinicKpi(c.clinicId)">
              KPI &nbsp; <i class="fas fa-arrow-left"></i
            ></a>
          </div>

          <div *ngIf="toggleSnoozeInput" class="snooze-input-area">
            <div class="inputs">
              <input-wrap cssClass="l-cell-spread w-full">
                <input
                  type="text"
                  [(ngModel)]="snoozeNote"
                  class="t-input"
                  placeholder="הערה"
                />
              </input-wrap>

              <input-wrap cssClass="l-cell-spread w-full">
                <p-datepicker
                  placeholder="עד תאריך"
                  dateFormat="dd/mm/yy"
                  [(ngModel)]="snoozeEndDate"
                  readonlyInput="readonlyInput"
                  showButtonBar="true"
                  appendTo="body"
                ></p-datepicker>
              </input-wrap>
            </div>
            <button (click)="activateSnooze(c.clinicId)" class="t-button">
              הפעלה
            </button>
          </div>
        </slide-in-out>
      </div>
    </div>
  </div>
</modal-popup>
